import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import SegmentedPicker from '../../../common/controls/segmentedPicker';
import entityComposition from '../../../common/classes/entityComposition';
import mapSettingsSelector from '../../selectors/mapSettingsSelector';
const MapTypePicker = ({
  map: {
    selectedMapType
  } = {
    selectedMapType: 'standard'
  },
  mapActions: {
    setMapType
  },
  mapSettings: {
    defaultMapType
  }
}) => {
  useEffect(() => {
    if (!selectedMapType) {
      setMapType(defaultMapType);
    }
  }, [selectedMapType, setMapType, defaultMapType]);
  const handleSelectedTypeChange = newType => {
    if (newType && newType !== selectedMapType) {
      setMapType(newType);
    }
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-ifp-title"
  }, "Map Type")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(SegmentedPicker, {
    hideLabel: true,
    value: selectedMapType,
    names: ['Standard', 'Satellite', 'Hybrid'],
    values: ['standard', 'satellite', 'hybrid'],
    onChange: handleSelectedTypeChange,
    className: "no-margin-bottom"
  })))));
};
MapTypePicker.propTypes = {
  map: PropTypes.shape({
    selectedMapType: PropTypes.string
  }),
  mapActions: PropTypes.shape({
    setMapType: PropTypes.func
  }).isRequired,
  mapSettings: PropTypes.shape({
    defaultMapType: PropTypes.string
  }).isRequired
};
export { MapTypePicker as TestMapTypePicker };
export default entityComposition(MapTypePicker, ['map'], {
  mapSettings: mapSettingsSelector
}, []);